<div class="calendar-container">
  <!-- Header -->
  <div class="calendar-header">
    <button class="nav-btn" (click)="prevMonth()">&#10094;</button>
    <div class="calendar-title">{{ getMonthYearLabel() }}</div>
    <button class="nav-btn" (click)="nextMonth()">&#10095;</button>
  </div>

  <!-- Weekdays -->
  <div class="calendar-grid weekday-header">
    <div *ngFor="let day of ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']">{{ day }}</div>
  </div>

  <!-- Calendar body -->
  <div class="calendar-grid">
    <ng-container *ngFor="let week of weeks">
      <ng-container *ngFor="let day of week">
        <div class="day-cell">
          <div
            class="cell-inner"
            (click)="selectCalendarDay(day)"
            [ngClass]="isSameDay(day, selectedDay) ? 'calendarSelected' : isToday(day) ? 'calendarToday' : ''"
          >
            <div class="date-number" [class.muted]="day.getMonth() !== currentMonth">
              {{ day.getDate() }}
            </div>

            <ng-container *ngIf="getUnavailabilityForDay(day) as countOfSC">
              <div
                *ngIf="countOfSC > 0"
                class="bar start end"
                matTooltipPosition="above"
              >
                {{ countOfSC + (countOfSC > 1 ? ' users' : ' user') }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
